export const getMonto: (data: any, s3folder: string) => number = (data, s3folder) => {
  const isMacstoreMexico = s3folder === 'ti_macstore'
  const isSamsungMexico = s3folder === 'ti_samsung_mx'
  const isConectaPeru = s3folder === 'ti_conecta_peru'
  const isSamsungRom = s3folder === 'ti_samsung_pe_rom'
  const isFalabellaPeru = s3folder === 'ti_falabella_pe'
  const isTelcelMexico = s3folder === 'ti_telcel_mx'
  const isTelcelCorpMexico = s3folder === 'ti_telcel_corp_mx'
  const isXiaomiMexico = s3folder === 'ti_xiaomi'
  const isOppoMexico = s3folder === 'ti_oppo'
  const isElektraMexico = s3folder === 'ti_elektra_mx'
  const isMercadoLibreChile = s3folder === 'ti_mercado_libre_cl'
  const isCoppelMexico = s3folder === 'ti_coppel'

  const weigth = 100
  let resultado = 0

  const sumaPeso = data.answers.reduce((valorAnterior: any, valorActual: any) => { return valorAnterior + valorActual.weigth }, 0)
  if (sumaPeso >= 100 && (!isSamsungRom && !isConectaPeru)) {
    return 0
  }
  console.log('🚀 ~ sumaPeso:', sumaPeso)
  if (isMacstoreMexico && data.sbu.id_sbu === 2) {
    const result = weigth - sumaPeso
    console.log('🚀 ~ getMonto ~ data.listMacbookGrades:', data.listMacbookGrades)
    if (result === 100) {
      resultado = data.listMacbookGrades.find((ele: any) => ele.grade === 'A').amountMacbook
    } else if (result > 90) {
      resultado = data.listMacbookGrades.find((ele: any) => ele.grade === 'B').amountMacbook
    } else if (result > 70) {
      resultado = data.listMacbookGrades.find((ele: any) => ele.grade === 'C').amountMacbook
    }
  } else if (isMacstoreMexico && data.sbu.id_sbu !== 2) {
    const result = weigth - sumaPeso
    if (result === 100) {
      resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'A').amount
    } else if (result > 90) {
      resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'B').amount
    } else if (result > 70) {
      resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'C').amount
    }
  } else if (isSamsungMexico) {
    if (data.sbu.id_sbu !== 5) {
      const hasValidCapacity = data.capacityModel.some(
        (ele: any) => ele.id_capacity !== null && ele.id_capacity !== undefined
      )
      if (hasValidCapacity) {
        const result = weigth - sumaPeso
        if (result === 100) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'A').amount
        } else if (result > 90) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'B').amount
        }
      } else {
        console.log('es samsung mx sin id_capacity', data.capacityModel)
        const result = weigth - sumaPeso
        if (result === 100) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'A').amount
        } else if (result > 90) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'B').amount
        }
      }
    } else {
      const result = weigth - sumaPeso
      console.log('es smartwatch samsung mx, result:', result)
      console.log('data.capacityModel:', data.capacityModel)
      if (result === 100) {
        console.log('buscando grado A')
        resultado = data.capacityModel.find((ele: any) => ele.grade === 'A').amount
      } else if (result > 90) {
        console.log('buscando grado B')
        resultado = data.capacityModel.find((ele: any) => ele.grade === 'B').amount
      }
    }
  } else if (isXiaomiMexico || isOppoMexico || isElektraMexico || isMercadoLibreChile || isCoppelMexico) {
    if (data.sbu.id_sbu !== 5) {
      const hasValidCapacity = data.capacityModel.some(
        (ele: any) => ele.id_capacity !== null && ele.id_capacity !== undefined
      )
      if (hasValidCapacity) {
        const result = weigth - sumaPeso
        if (result === 100) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'A').amount
        } else if (result > 90) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'B').amount
        } else if (result > 70) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'C').amount
        }
      } else {
        console.log('Es oppo o xiaomi sin capacity', data.capacityModel)
        const result = weigth - sumaPeso
        if (result === 100) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'A').amount
        } else if (result > 90) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'B').amount
        } else if (result > 70) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'C').amount
        }
      }
    }
  } else if (isTelcelMexico || isTelcelCorpMexico) {
    if (data.sbu.id_sbu !== 5) {
      const hasValidCapacity = data.capacityModel.some(
        (ele: any) => ele.id_capacity !== null && ele.id_capacity !== undefined
      )
      if (hasValidCapacity) {
        const result = weigth - sumaPeso
        if (result === 100) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'A').amount
        } else if (result > 90) {
          resultado = data.capacityModel.find((ele: any) => ele.id_capacity === data.capacity.id_capacity && ele.grade === 'B').amount
        }
      } else {
        console.log('es telcel mx sin id_capacity', data.capacityModel)
        const result = weigth - sumaPeso
        if (result === 100) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'A').amount
        } else if (result > 90) {
          resultado = data.capacityModel.find((ele: any) => ele.grade === 'B').amount
        }
      }
    } else {
      const result = weigth - sumaPeso
      console.log('es smartwatch telcel mx, result:', result)
      console.log('data.capacityModel:', data.capacityModel)
      if (result === 100) {
        console.log('buscando grado A')
        resultado = data.capacityModel.find((ele: any) => ele.grade === 'A').amount
      } else if (result > 90) {
        console.log('buscando grado B')
        resultado = data.capacityModel.find((ele: any) => ele.grade === 'B').amount
      }
    }
  } else if (isSamsungRom || isConectaPeru) {
    const result = weigth - sumaPeso

    // Verifica si los elementos tienen id_capacity
    const hasValidCapacity = data.capacityModel.some(
      (ele: any) => ele.id_capacity !== null && ele.id_capacity !== undefined
    )
    console.log('🚀 ~ getMonto ~ hasCapacity:', hasValidCapacity)
    const getAmountByGrade = (grade: string) => {
      return data.capacityModel.find((ele: any) => {
        if (hasValidCapacity) {
          return ele.id_capacity === data.capacity.id_capacity && ele.grade === grade
        } else {
          return ele.grade === grade
        }
      })?.amount ?? 0
    }

    if (result === 100) {
      resultado = getAmountByGrade('A')
    } else if (result > 92) {
      resultado = getAmountByGrade('B')
    } else if (result >= 75) {
      resultado = getAmountByGrade('C')
    } else {
      console.log('🚀 ~ getMonto ~ data.capacityModel:', data.capacityModel)
      resultado = getAmountByGrade('D') // 0 En grado D antes estaba en 0
    }
  } else if (isFalabellaPeru) {
    resultado = data.capacity.id_capacity > 0 ? data.capacity.amount - ((data.capacity.amount * sumaPeso) / 100) : data.model.amount - ((data.model.amount * sumaPeso) / 100)
    console.log('🚀 ~ resultado normal:', resultado)
    // es necesario redondear el resultado siempre hacia arriba y que sea un multiplo de 50
    resultado = Math.ceil(resultado / 50) * 50
    console.log('🚀 ~ resultado redondeado:', resultado)
  } else {
    resultado = data.capacity.id_capacity > 0 ? data.capacity.amount - ((data.capacity.amount * sumaPeso) / 100) : data.model.amount - ((data.model.amount * sumaPeso) / 100)
  }

  return resultado
}

export const getMontoConsola: (data: any, s3folder: string, extraControls: number | null) => number = (data, s3folder, extraControls) => {
  const isConectaPeru = s3folder === 'ti_conecta_peru'
  const isSamsungRom = s3folder === 'ti_samsung_pe_rom'

  const sumaPeso = data.answers.reduce((valorAnterior: any, valorActual: any) => { return valorAnterior + valorActual.weigth }, 0)
  if (sumaPeso >= 100 && (!isSamsungRom && !isConectaPeru)) {
    return 0
  }
  const result = data.capacity.id_capacity > 0 ? data.capacity.amount - ((data.capacity.amount * sumaPeso) / 100) : data.model.amount - ((data.model.amount * sumaPeso) / 100)
  return result + (extraControls ? Number(extraControls) * Number(import.meta.env.VITE_EXTRA_CONSOLA) : 0)
}
